// extracted by mini-css-extract-plugin
export var container = "_ta-0";
export var table = "_ta-2";
export var tableWrapper = "_ta-1";